import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofSection() {
  return <section className="py-20 bg-[#1A5C4C] text-white" data-id="element-181">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-182">
        <FadeIn data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-serif mb-10 text-[#FDF6F0]" data-id="element-184">
            Qué cambia en los primeros 7 días:
          </h2>
          <div className="bg-white/10 p-8 md:p-12 rounded-3xl backdrop-blur-sm border border-white/20" data-id="element-185">
            <p className="text-xl md:text-2xl leading-relaxed font-serif italic" data-id="element-186">
              "Notarás que la inflamación de tu rostro desaparece, tus niveles
              de energía se mantienen estables después de almuerzo y, por
              primera vez en meses, dormirás 7 horas seguidas sin despertarte
              con calor o ansiedad a las 3 AM."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}